export enum MODAL_TYPES {
    participantList = 'participant-list',
    commandList = 'command-list',
    debugMenu = 'debug-menu',
}
